<template>
  <div class="app-container">
    <van-nav-bar title="历史上传" :right-text="ym" left-arrow
                 @click-left="$router.push('/home')"
                 @click-right="showDate = true"
    />
    <my-company />

    <van-row>
      <van-col span="12" style="text-align: center">上传批次</van-col>
      <van-col span="12" style="text-align: center">所属账期</van-col>
    </van-row>

    <van-pull-refresh v-model="refreshing" @refresh="query()">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="query()"
      >
        <van-cell v-for="row in data" :key="row.id" :title="row.batch" :value="row.curr_date"
                  :label="row.create_time" :clickable="true" @click="viewDetails(row)" />
      </van-list>
    </van-pull-refresh>
    <change-ym :show="showDate" @change="onYmChange" />

    <van-popup v-model="showDetails" position="top" :style="{ height: '70%' }" closeable>
      <template v-for="file in historyFiles">
        <a target="_blank" :href="BASE_URL + '/' + file.img_url + '?open_id=' + openId + '&cx_user=' + CONST.CX_USER">
          {{ file.fileName }}
        </a>
      </template>
      <template v-for="(image, index) in historyImages">
        <van-image width="10rem" height="10rem" :key="image.id" style="margin-left: 0.3rem;"
                   :src="BASE_URL + '/' + image.img_url + '?open_id=' + openId + '&cx_user=' + CONST.CX_USER"
                   @click="handlePreview(index)" />
      </template>
    </van-popup>

    <van-image-preview v-model="showPreview" :images="historyImagesUrl" :start-position="startPosition" :closeable="true" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getElecnotesList, getElecnotesDetail } from '@/api/elecnotes'
import MyCompany from '../commons/my-company'
import ChangeYm from '../commons/change-ym'
export default {
  components: { MyCompany, ChangeYm },
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      showDetails: false,
      showPreview: false,

      startPosition: 0,

      showDate: false,
      ym: this.$store.getters.currYm,
      data: [],
      historyImages: [],
      historyImagesUrl: [],
      historyFiles: [],

      BASE_URL: this.VUE_APP_BASE_API
    }
  },
  computed: {
    ...mapGetters(['openId', 'currClient'])
  },
  mounted() {
    this.query()
  },
  methods: {
    handlePreview(index) {
      this.startPosition = index
      this.showPreview = true
    },
    query() {
      this.finished = false
      this.loading = true

      if (this.refreshing) {
        this.data = []
        this.refreshing = false
      }

      getElecnotesList({
        is_phone: true,
        create_id: 0,
        page: 1,
        rows: 9999,
        sort: 'id',
        order: 'desc',
        client_id: this.currClient.client_id,
        curr_date: this.ym + '-01'
      }).then(resp => {
        this.data = resp.rows || []
        this.loading = false
        this.finished = true
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },
    viewDetails(row) {
      getElecnotesDetail({
        id: row.id,
        create_id: 0
      }).then(resp => {
        this.historyImages = []
        this.historyImagesUrl = []
        this.historyFiles = []
        const fileList = resp.rows || []
        fileList.forEach(file => {
          let filePos = file.img_url.lastIndexOf('/')
          file.fileName = file.img_url.substring(filePos + 1)
          let suffixPos = file.img_url.lastIndexOf('.')
          let suffixName = file.img_url.substring(suffixPos + 1)
          file.isImg = this.CONST.UPLOAD.IMAGE_TYPES.find(type => type === suffixName) ? true : false
          if (file.isImg) {
            this.historyImages.push(file)
            this.historyImagesUrl.push(this.VUE_APP_BASE_API + '/' +
              file.img_url + '?open_id=' + this.openId + '&cx_user=' + this.CONST.CX_USER)
          } else {
            this.historyFiles.push(file)
          }
        })
        this.showDetails = true
      })
    },
    onYmChange(show, ym) {
      this.showDate = show
      if (ym) {
        this.ym = ym
        this.query()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/history.vue